import * as z from "zod";

export const deleteConciergeKnowledge = {
  name: "deleteConciergeKnowledge" as const,
  input: z.object({ _id: z.string() }),
  output: z.null(),
};
